module.exports = __webpack_public_path__ + "static/media/quote-icon.78c302a6.svg";